import { CmhVatInfoState } from '@/store/new-connection-cmh/cmh-vat-info/types'
import { RootState } from '@/store/types'
import { GetterTree } from 'vuex'

export const getters: GetterTree<CmhVatInfoState, RootState> = {}
